import { render } from "./ManagerSigningPage.vue?vue&type=template&id=70857cdd&scoped=true&ts=true"
import script from "./ManagerSigningPage.vue?vue&type=script&lang=ts"
export * from "./ManagerSigningPage.vue?vue&type=script&lang=ts"

import "./ManagerSigningPage.vue?vue&type=style&index=0&id=70857cdd&scoped=true&lang=css"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70857cdd"]])

export default __exports__